import fetch from '@/plugin/axios'

// 添加分类
export function getAddclassify (query) {
  return fetch({
    url: '/api/order/clock-in-classify/add',
    method: 'Post',
    data: query
  })
}
// 分类选项
export function getOptions () {
  return fetch({
    url: `/api/order/clock-in-classify/options/''`,
    method: 'Get'
  })
}

// 查询列表
export function getList (query) {
  return fetch({
    url: '/api/order/clock-in-classify/list',
    method: 'Post',
    data: query
  })
}

// 修改分类
export function getUpdate (query, id) {
  return fetch({
    url: `/api/order/clock-in-classify/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 分类信息
export function getInfo (id) {
  return fetch({
    url: `/api/order/clock-in-classify/info/${id}`,
    method: 'Get'
  })
}

// 删除分类
export function getRemove (id) {
  return fetch({
    url: `/api/order/clock-in-classify/remove/${id}`,
    method: 'Get'
  })
}

// 添加标签
export function getAddTap (query) {
  return fetch({
    url: '/api/order/clock-in-tag/add',
    method: 'Post',
    data: query
  })
}

// 查询标签
export function getTagys (query) {
  return fetch({
    url: '/api/order/clock-in-tag/list',
    method: 'Post',
    data: query
  })
}

// 修改标签
export function tagUpdate (query, id) {
  return fetch({
    url: `/api/order/clock-in-tag/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 标签信息
export function tagInfo (id) {
  return fetch({
    url: `/api/order/clock-in-tag/info/${id}`,
    method: 'Get'
  })
}

// 删除标签
export function tagRemove (id) {
  return fetch({
    url: `/api/order/clock-in-tag/remove/${id}`,
    method: 'Get'
  })
}

// 分类选项
export function tagOptions () {
  return fetch({
    url: `/api/order/clock-in-tag/options`,
    method: 'Get'
  })
}
